import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const FlowKpiIcon = ({ color }: { color?: string }) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorIcon;

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_936_11490)">
        <path
          d="M8 1C8 0.723858 7.77614 0.5 7.5 0.5C6.57174 0.5 5.6815 0.868749 5.02513 1.52513C4.36875 2.1815 4 3.07174 4 4C4 4.92826 4.36875 5.8185 5.02513 6.47487C5.6815 7.13125 6.57174 7.5 7.5 7.5C7.77614 7.5 8 7.27614 8 7V1Z"
          fill={currentColor}
        />
        <path
          d="M15 8C15.2761 8 15.5 7.77614 15.5 7.5C15.5 6.57174 15.1313 5.6815 14.4749 5.02513C13.8185 4.36875 12.9283 4 12 4C11.0717 4 10.1815 4.36875 9.52513 5.02513C8.86875 5.6815 8.5 6.57174 8.5 7.5C8.5 7.77614 8.72386 8 9 8H15Z"
          fill={currentColor}
        />
        <path
          d="M1 8C0.723858 8 0.5 8.22386 0.5 8.5C0.5 9.42826 0.868749 10.3185 1.52513 10.9749C2.1815 11.6313 3.07174 12 4 12C4.92826 12 5.8185 11.6313 6.47487 10.9749C7.13125 10.3185 7.5 9.42826 7.5 8.5C7.5 8.22386 7.27614 8 7 8H1Z"
          fill={currentColor}
        />
        <path
          d="M8 15C8 15.2761 8.22386 15.5 8.5 15.5C9.42826 15.5 10.3185 15.1313 10.9749 14.4749C11.6313 13.8185 12 12.9283 12 12C12 11.0717 11.6313 10.1815 10.9749 9.52513C10.3185 8.86875 9.42826 8.5 8.5 8.5C8.22386 8.5 8 8.72386 8 9V15Z"
          fill={currentColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_936_11490">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FlowKpiIcon;
